"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "btn-wrapper" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const OcrIcon_vue_1 = __importDefault(require("../view/assets/icons/OcrIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'OcrDownloadModal',
    setup(__props) {
        const isVisible = (0, vue_3.ref)(false);
        const isLoading = (0, vue_3.ref)(false);
        // Methods
        function closeModal() {
            isVisible.value = false;
        }
        function openModal() {
            isVisible.value = true;
        }
        // Computed properties
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? "loading" : "";
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (isVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                        key: 0,
                        onCloseModal: closeModal,
                        "has-title-divider": true,
                        "has-footer-divider": true
                    }, {
                        "header-title": (0, vue_2.withCtx)(() => [...(_cache[0] || (_cache[0] = [
                                (0, vue_2.createTextVNode)(" OCRタイムシート ", -1 /* CACHED */)
                            ]))]),
                        content: (0, vue_2.withCtx)(() => [...(_cache[1] || (_cache[1] = [
                                (0, vue_2.createElementVNode)("div", { class: "content-wrapper" }, [
                                    (0, vue_2.createTextVNode)(" OCRタイムシートを印刷しシフトを記入することが出来ます。"),
                                    (0, vue_2.createElementVNode)("br"),
                                    (0, vue_2.createElementVNode)("br"),
                                    (0, vue_2.createTextVNode)(" サイズはA4、黒インクで印刷をしてください。"),
                                    (0, vue_2.createElementVNode)("br"),
                                    (0, vue_2.createTextVNode)(" なお、記入したシートはシフト管理のクイックスキャンにて読み込むことで、シフトをインポートすることが可能です。 ")
                                ], -1 /* CACHED */)
                            ]))]),
                        "footer-btn": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                (0, vue_2.createElementVNode)("a", {
                                    class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-alt-confirm-btn p-1"]),
                                    href: "https://storage.googleapis.com/opluswork.com/dashboard/static/dashboard/empty_ocr_sheet6.pdf",
                                    target: "_blank",
                                    download: "empty_ocr_sheet.png"
                                }, " ダウンロード ", 2 /* CLASS */),
                                _cache[2] || (_cache[2] = (0, vue_2.createTextVNode)("   ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("a", {
                                    class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-alt-confirm-btn p-1"]),
                                    href: "/dashboard/empty_ocr_sheet_print.html",
                                    target: "_blank"
                                }, " 印刷 ", 2 /* CLASS */)
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#ocr-download-modal-btn" }, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "footer-btn-alt text-center c-hand",
                        onClick: openModal
                    }, [
                        (0, vue_2.createVNode)(OcrIcon_vue_1.default),
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", null, "OCR", -1 /* CACHED */))
                    ])
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
